// ** React Imports
import { matchPath, useLocation } from "react-router";

// ** Custom Components
import Block from "components/layout/Block";
import { StyledPanelWrapper } from "containers/Landing/components/AuthPanel/styles/PanelWrapper.styled";
import RegisterVerifyPhone from "containers/Landing/containers/RegisterVerify/RegisterVerifyPhone";
import RegisterVerifySubmitCode from "containers/Landing/containers/RegisterVerify/RegisterVerifySubmitCode";

// ** Styled Components
import { StyledModalAuthContentWrapper } from "./styles/ModalAuthContentWrapper.styled";
import { StyledModalAuthMainSection } from "./styles/ModalAuthMainSection.styled";
import { StyledModalVerifyPhoneBody } from "./styles/ModalVerifyPhoneBody.styled";

// #####################################################

const ModalVerifyPhoneContent = ({ innerRef }) => {
	const location = useLocation();

	const isSubmitPhoneNumberPath = matchPath(location.pathname, {
		path: "/registration-phone/:login?/:id?/:hash?",
		exact: true,
		sensitive: true,
		strict: false,
	});

	const isSubmitCodePath = matchPath(location.pathname, {
		path: "/registration-code/:login?/:id?/:hash?",
		exact: true,
		sensitive: true,
		strict: false,
	});

	// #####################################################

	return (
		<StyledModalAuthMainSection>
			<Block flex flexWrap fullWidth>
				<StyledModalAuthContentWrapper ref={innerRef}>
					<StyledPanelWrapper>
						<StyledModalVerifyPhoneBody>
							{isSubmitPhoneNumberPath && <RegisterVerifyPhone />}
							{isSubmitCodePath && <RegisterVerifySubmitCode />}
						</StyledModalVerifyPhoneBody>
					</StyledPanelWrapper>
				</StyledModalAuthContentWrapper>
			</Block>
		</StyledModalAuthMainSection>
	);
};

// #####################################################

export default ModalVerifyPhoneContent;

// #####################################################
